// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"a923b29a","859":"a5a8c17d","976":"f23f3b79"}[chunkId] + ".chunk.css";
};